import React, { Component } from 'react';
import '../css/formats.css';
import { PartialPaymentModal, CollectionModal } from '../components';
import SeriesCreateModal from './SeriesCreateModal';
import AccountListModal from './AccountListModal';
import CheckListModal from './CheckListModal';
import PaymentCreditCardsModal from './PaymentCreditCardsModal';
import moment from "moment";

class CollectModal extends Component {

  render() {
    const {
      ShowCollectModalModal,
      ModelCollect,
      SelectDocDate,
      SelectDocDueDate,
      OpenSeries,
      ShowOpenSeriesModal,
      series,
      SelectSeries,
      cleanDataSeries,
      ChangeTotalInvoicePayment,
      ValidateTotalInvoicePaymentNull,
      OpenCuentaMayor,
      ShowAccountsModal,
      accounts,
      cleanDataAccounts,
      SelectAccountList,
      changeCashSumEnter,
      changeCashSum,
      validateCashSumNull,
      Abonar,
      changeTrsfrSum,
      validateTrsfrSumNull,
      openCheckList,
      checkItemCreateInfo,
      ShowCheckListModal,
      refreshTotal,
      addNewItemCheck,
      deleteItemCheck,
      changeAccountCashAcct,
      changeAccountCheck,
      changeAccountTrsfr,
      ShowPaymentCreditCardsModal,
      OpenPaymentCreditCards,
      ClosePaymentCreditCardsModal,
      refreshModel,
      selectTabCard,
      addCreditCard,
      deleteCard,
      openCard,
      cardList,
      validateCardNum,
      changeCardNum,
      changeCardValid,
      changeValidateValidCard,
      changeOwnerIdNum,
      changeOwnerPhone,
      keydownHandler,
      changeCreditSum,
      changeTransfersRef,
      changeVoucherNum,
      changeCreditType,
      changeCreditSumOne,
      selectCardList,
      cleanCardList,
      ShowAccountsModalCredit,
      accountsCredit,
      SelectAccountListCredit,
      cleanDataAccountsCredit,
      OpenCuentaMayorCredit,

      AplicarPago,
      // showAlert,
      // showBillModal,
      addingPay,
      AvailablePayments,
      BankAccounts,
      DownPayments,
      CreditNotes,

      PaymentSaleModel,
      // ShowBillModal,
      // CloseBillModal,
      // RefreshOrder,
      // CancelPayment,
      // ValidateDocument,
      // ValidateInvoice,
      // ShowPDFViewer,
      // RefreshPaymentSaleModel,
      // GetBankAccounts,
      // CreateDocument,
      AddPay,
      // GetDownPaymentsByPartner,
      // CheckIfItsUniversalPartner,
      // PrintDocuments,

      findInName,
      ChangeTypePayMethod,
      DoSearch_1,
      ChangePaycheckNum,
      ChangeDatePayCheck,
      ChangeBank,
      ChangeCardNum,
      ChangeVoucherNum,
      ChangeIndentification,
      ChangePhoneNum,
      ChangeValidCard,
      ChangeValidateValidCard,
      ChangeTransferNum,
      ChangePayAccountNum,
      ChangeReturnFolio,
      ChangeDocEntryDP,
      ChangeDocEntryCN,
      ChangeAmount,
      addingPaymentSale,
      RemovePaymentSale,
      ChangeParcialidadInvoicePayment,
      FlagPayWithSantander,
      formatNumber,
      SelectU_BPP_PTSCPaymentDefault,
      showNiubizModal,
      currPayment,
      allSN = false,
      globalCurrency = '',
      onChangeVoucher,
      validateVoucher,
      bankOptions = [],
      RemovePaymentSaleByNiubiz,
      addNiubizReference,
      showAlert,
      changeCFW,
      currencys,
    } = this.props;
    AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
    let totalPago = 0;
    for (let index = 0; index < ModelCollect.ItemsPayments?.length; index++) {
      const element = ModelCollect.ItemsPayments[index];
      totalPago += Number(element.totalPago) + Number(element.U_PRC_IMP) + Number(element?.MontoCU || 0);
      ModelCollect.docType = ModelCollect.DocType;
    }
    ModelCollect.totalPago = parseFloat(totalPago).toFixed(2);
    ModelCollect.totalDocumento = ModelCollect.totalPago;

    ModelCollect.totalRestante = (ModelCollect.totalPago) - (Number(ModelCollect.CashSum) + Number(ModelCollect.CreditSum) + Number(ModelCollect.CheckSum) + Number(ModelCollect.TrsfrSum));
    const multipleClients = [...new Set(ModelCollect.ItemsPayments?.map(i => i.CardCode))].length > 1;
    let flagSeriesAndConsecutives = false;
    if (ModelCollect.ItemsPayments?.some(row => row.U_PRC_IMP > 0)) {
      flagSeriesAndConsecutives = true;
      ModelCollect.U_BPP_MDTDPaymentDefault = 40;
    }

    return (

      <div>
        <div className="modal fade" id="collectModal" data-keyboard="true" tabIndex="-1" aria-labelledby="collectModalLabel" aria-hidden="true" >
          <div className="modal-dialog modal-xl" >
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={ShowCollectModalModal} style={{ marginTop: "-8px" }}>
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className='m-4'>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        {!allSN &&
                          <>
                            <div className='col-12 col-sm-6 col-md-6 col-lg-4 text-left mb-2'>
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text"><strong>Cliente</strong></span>
                                </div>
                                <input type="text" className="form-control" disabled placeholder={ModelCollect.CardCode || ModelCollect.ItemsPayments?.[0]?.CardCode || ''} />
                              </div>
                            </div>
                            <div className='col-12 col-sm-6 col-md-6 col-lg-4 text-left mb-2'>
                              <div className="input-group ">
                                <div className="input-group-prepend">
                                  <span className="input-group-text" ><strong>Nombre</strong></span>
                                </div>
                                <input type="text" className="form-control" disabled placeholder={(ModelCollect.U_FMB_AUX_CARDNAME || ModelCollect.CardName) || (ModelCollect.ItemsPayments?.[0]?.U_FMB_AUX_CARDNAME || ModelCollect.ItemsPayments?.[0]?.CardName || '')} />
                              </div>
                            </div>
                          </>
                        }
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 text-left mb-2">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text"><strong>Serie</strong></span>
                            </div>
                            <input type="text" className="form-control" disabled placeholder={ModelCollect.SerieName} />
                            <div className="input-group-append">
                              <button
                                type="button"
                                style={{ backgroundColor: 'transparent', }}
                                className="input-group-text"
                                onClick={OpenSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-4 mb-4 mt-2'>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <strong className="d-none d-xl-inline">F. Documento</strong>
                                <strong className="d-inline d-xl-none">F. Doc</strong>
                              </span>
                            </div>
                            <input type="date" className="form-control" value={ModelCollect.TaxDate} max='9999-12-31' />
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4 mt-2">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <strong className="d-none d-xl-inline">F. Contabilización</strong>
                                <strong className="d-inline d-xl-none">F. Conta</strong>
                              </span>
                            </div>
                            <input type="date" className="form-control" value={ModelCollect.DocDate} onChange={SelectDocDate} max='9999-12-31' />
                          </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-4 mb-4 mt-2'>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <strong className="d-none d-xl-inline">F. Vencimiento</strong>
                                <strong className="d-inline d-xl-none">F. Venc</strong>
                              </span>
                            </div>
                            <input type="date" className="form-control" value={ModelCollect.DocDueDate} onChange={SelectDocDueDate} max='9999-12-31' />
                          </div>
                        </div>
                      </div>
                      {!allSN &&
                        <div className="row d-flex align-items-center justify-content-center">
                          <div className='col-12 col-sm-6 col-md-6 col-lg-4 mb-4'>
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                  <span className="d-none d-xl-inline">Tipo de documento</span>
                                  <span className="d-inline d-xl-none">Tipo Doc</span>
                                </span>
                              </div>
                              <input type="text" className="form-control" disabled value={flagSeriesAndConsecutives ? ModelCollect.U_BPP_MDTDPaymentDefault : ''} />
                            </div>
                          </div>
                          <div className='col-12 col-sm-6 col-md-6 col-lg-4 mb-4'>
                            <div className="input-group ">
                              <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                  <span className="d-none d-xl-inline">Serie de documento</span>
                                  <span className="d-inline d-xl-none">Serie doc</span>
                                </span>
                              </div>
                              <input type="text" className="form-control" value={flagSeriesAndConsecutives ? ModelCollect.U_BPP_PTSCPaymentDefault : ''} onChange={(event) => flagSeriesAndConsecutives && SelectU_BPP_PTSCPaymentDefault(event.nativeEvent.target.value)} />
                            </div>
                          </div>
                        </div>
                      }
                      <div className="table-responsive">
                        <div className='card scrollFacCollect' style={{ maxHeight: "335px" }}>
                          <table className="table table-striped table-hover">
                            <thead className='sticky-headerPOS' style={{ backgroundColor: 'white', zIndex: "3 !important" }}>
                              <tr>
                                {allSN && <>
                                  <th className="col-2 text-center" scope="col">
                                    Cliente
                                  </th>
                                  <th className="col-2 text-center" scope="col">
                                    Nombre
                                  </th>
                                </>}
                                <th className="col-2 text-center" scope="col">
                                  Tipo
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  No. documento
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  No.Ref.de. cliente
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Fecha
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Días de atraso
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Total
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Saldo vencido
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Cesión en uso
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Pago total
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Importe Percepción
                                </th>
                                <th className="col-2 text-center" scope="col">
                                  Parcialidad
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {!!ModelCollect.ItemsPayments && ModelCollect.ItemsPayments?.map((invoice, index) => {
                                return (
                                  <tr key={index} >
                                    {allSN && <>
                                      <td className="col-2 text-center">
                                        {invoice.CardCode ?? ''}
                                      </td>
                                      <td className="col-2 text-center"
                                        style={{
                                          minWidth: '200px'
                                        }}
                                      >
                                        {invoice.CardName ?? ''}
                                      </td>
                                    </>}
                                    <td className="col-2 text-center">
                                      {invoice.ObjType || ''}
                                    </td>
                                    <td className="col-2 text-center">
                                      <strong>{invoice.DocNum}</strong>
                                    </td>
                                    <td className="col-2 text-center" style={{ whiteSpace: 'nowrap' }}>
                                      <strong>{invoice.NumAtCard}</strong>
                                    </td>
                                    <td className="col-2 text-center" style={{ whiteSpace: 'nowrap' }}>{moment(invoice.DocDate).utc().format('YYYY-MM-DD')}</td>
                                    <td className="col-2 text-center" style={{ whiteSpace: 'nowrap' }}>{invoice.DIAS}</td>
                                    <td className="col-2 text-center" style={{ whiteSpace: 'nowrap' }}>{`${globalCurrency} ${Number(invoice.DocTotal).toFixed(2)}`}</td>
                                    <td className="col-2 text-center" style={{ whiteSpace: 'nowrap' }}>{`${globalCurrency} ${parseFloat(invoice.DocTotal - invoice.PorVencer).toFixed(2)}`}</td>
                                    <td className="col-2 text-center" style={{ whiteSpace: 'nowrap' }}>{`${globalCurrency} ${Number(invoice.MontoCU || 0).toFixed(2)}`}</td>
                                    <td className="col-2 text-center">
                                      {/* $ {invoice.PorVencer} */}
                                      <input
                                        style={{
                                          textAlign: 'right',
                                          backgroundColor: 'transparent',
                                          borderColor: '#ced4da',
                                          color: '#000',
                                          minWidth: '120px',
                                          maxWidth: '160px'
                                        }}
                                        type="number"
                                        step=".01"
                                        className="form-control btn-outline-secondary"
                                        id="txtDiscPrcnt"
                                        onChange={event => ChangeTotalInvoicePayment(event, index)}
                                        onBlur={() => ValidateTotalInvoicePaymentNull(index)}
                                        value={invoice.totalPago}
                                      />
                                    </td>
                                    {/* Importe Percepción */}
                                    <td style={{ textAlign: 'right' }}>
                                      <input
                                        style={{
                                          textAlign: 'right',
                                          backgroundColor: 'transparent',
                                          borderColor: '#ced4da',
                                          color: '#000',
                                          minWidth: '100px',
                                          maxWidth: '140px'
                                        }}
                                        type="text"
                                        className="form-control btn-outline-secondary"
                                        id="txtPerception"
                                        disabled={true}
                                        readOnly={true}
                                        value={`${formatNumber.new(invoice.U_PRC_IMP ?? 0)}`}
                                      />
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                      <input
                                        style={{
                                          textAlign: 'right',
                                          backgroundColor: 'transparent',
                                          borderColor: '#ced4da',
                                          color: '#000',
                                        }}
                                        type="text"
                                        className="form-control btn-outline-secondary"
                                        id="txtParcialidad"
                                        maxlength="4"
                                        onChange={event => ChangeParcialidadInvoicePayment(event, index)}
                                        value={invoice.U_Parcialidad}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12 col-sm-6 col-lg-9">
                        </div>
                        <div className="col-12 col-sm-6 col-lg-3 text-right">
                          <div className="input-group  mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Total vencido</span>
                                <span className="d-inline d-xl-none">Total vencido</span>
                              </span>
                            </div>
                            <input type="text" className="form-control text-right" disabled
                              value={`${globalCurrency} ${Number(ModelCollect.total).toFixed(2)}`}
                            />
                          </div>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Pago total</span>
                                <span className="d-inline d-xl-none">Pago total</span>
                              </span>
                            </div>
                            <input type="text" className="form-control text-right" disabled
                              value={`${globalCurrency} ${Number(ModelCollect.totalPago).toFixed(2)}`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary ml-2" data-dismiss="modal" onClick={ShowCollectModalModal}>Cerrar</button>
                <button
                  type="button"
                  className="btn btn-primary mr-2 ml-2"
                  // data-dismiss="modal" 
                  // data-toggle="modal" 
                  // data-target="#partialPaymentModal"
                  // onClick={() => Continue()}
                  onClick={() => AplicarPago()}
                >Abonar</button>
              </div>
            </div>
          </div>
        </div>
        {/* { ShowPaymentModal && ( */}
        <PartialPaymentModal
          ModelCollect={ModelCollect}
          OpenCuentaMayor={OpenCuentaMayor}
          changeCashSumEnter={changeCashSumEnter}
          changeCashSum={changeCashSum}
          validateCashSumNull={validateCashSumNull}

          changeTrsfrSum={changeTrsfrSum}
          validateTrsfrSumNull={validateTrsfrSumNull}

          openCheckList={openCheckList}
          Abonar={Abonar}
          changeAccountCashAcct={changeAccountCashAcct}
          changeAccountCheck={changeAccountCheck}
          changeAccountTrsfr={changeAccountTrsfr}
          OpenPaymentCreditCards={OpenPaymentCreditCards}
          refreshModel={refreshModel}
        />
        {/* )} */}

        <CollectionModal
          FlagPayWithSantander={FlagPayWithSantander}
          ModelCollect={ModelCollect}
          multipleClients={multipleClients}
          OpenCuentaMayor={OpenCuentaMayor}
          changeCashSumEnter={changeCashSumEnter}
          changeCashSum={changeCashSum}
          validateCashSumNull={validateCashSumNull}

          changeTrsfrSum={changeTrsfrSum}
          validateTrsfrSumNull={validateTrsfrSumNull}

          openCheckList={openCheckList}
          Abonar={Abonar}
          changeAccountCashAcct={changeAccountCashAcct}
          changeAccountCheck={changeAccountCheck}
          changeAccountTrsfr={changeAccountTrsfr}
          OpenPaymentCreditCards={OpenPaymentCreditCards}
          refreshModel={refreshModel}

          DownPayments={DownPayments}
          PaymentSaleModel={PaymentSaleModel}
          CreditNotes={CreditNotes}
          BankAccounts={BankAccounts}
          AvailablePayments={AvailablePayments}
          addingPay={addingPay}
          moment={moment}
          findInName={findInName}
          ChangeTypePayMethod={ChangeTypePayMethod}
          DoSearch_1={DoSearch_1}

          AddPay={AddPay}
          ChangePaycheckNum={ChangePaycheckNum}
          ChangeDatePayCheck={ChangeDatePayCheck}
          ChangeBank={ChangeBank}
          ChangeCardNum={ChangeCardNum}
          ChangeVoucherNum={ChangeVoucherNum}
          ChangeIndentification={ChangeIndentification}
          ChangePhoneNum={ChangePhoneNum}
          ChangeValidCard={ChangeValidCard}
          ChangeValidateValidCard={ChangeValidateValidCard}
          ChangeTransferNum={ChangeTransferNum}
          ChangePayAccountNum={ChangePayAccountNum}
          ChangeReturnFolio={ChangeReturnFolio}
          ChangeDocEntryDP={ChangeDocEntryDP}
          ChangeDocEntryCN={ChangeDocEntryCN}
          ChangeAmount={ChangeAmount}
          addingPaymentSale={addingPaymentSale}
          RemovePaymentSale={RemovePaymentSale}
          showNiubizModal={showNiubizModal}
          currPayment={currPayment}
          onChangeVoucher={onChangeVoucher}
          validateVoucher={validateVoucher}
          bankOptions={bankOptions}
          RemovePaymentSaleByNiubiz={RemovePaymentSaleByNiubiz}
          addNiubizReference={addNiubizReference}
          showAlert={showAlert}
          changeCFW={changeCFW}
          currencys={currencys}
        />

        {ShowOpenSeriesModal && (
          <SeriesCreateModal
            data={series}
            selectSerie={SelectSeries}
            cleanData={cleanDataSeries}
          />
        )}

        {ShowAccountsModal && (
          <AccountListModal
            data={accounts}
            selectAccount={SelectAccountList}
            cleanData={cleanDataAccounts}
          />
        )}
        {ShowCheckListModal && (
          <CheckListModal
            action={1}
            model={ModelCollect}
            dataInfo={checkItemCreateInfo}
            refreshTotal={refreshTotal}
            addNewItem={addNewItemCheck}
            deleteItem={deleteItemCheck}
          />
        )}
        {ShowPaymentCreditCardsModal && (
          <PaymentCreditCardsModal
            model={ModelCollect}
            cleanData={ClosePaymentCreditCardsModal}
            refreshModel={refreshModel}
            selectTabCard={selectTabCard}
            addCreditCard={addCreditCard}
            deleteCard={deleteCard}
            openCard={openCard}

            OpenCuentaMayorCredit={OpenCuentaMayorCredit}
            validateCardNum={validateCardNum}
            changeCardNum={changeCardNum}
            changeCardValid={changeCardValid}
            changeValidateValidCard={changeValidateValidCard}
            changeOwnerIdNum={changeOwnerIdNum}
            changeOwnerPhone={changeOwnerPhone}
            keydownHandler={keydownHandler}
            changeCreditSum={changeCreditSum}
            changeTransfersRef={changeTransfersRef}
            changeVoucherNum={changeVoucherNum}
            changeCreditType={changeCreditType}
            changeCreditSumOne={changeCreditSumOne}

            selectCardList={selectCardList}
            cardList={cardList}
            cleanCardList={cleanCardList}

            ShowAccountsModalCredit={ShowAccountsModalCredit}
            accountsCredit={accountsCredit}
            SelectAccountListCredit={SelectAccountListCredit}
            cleanDataAccountsCredit={cleanDataAccountsCredit}
          />
        )}
      </div>
    );
  }
}

export default CollectModal;